import { Link } from 'react-router-dom';
import { services } from '@/mocks/team';

const tags = ['Search. Selection. Fit.', 'Clarity. Counsel. Confidence.', 'Culture. Teams. Growth.'];

export default function ExpertiseSection() {
  return (
    <section className="chapter-fg py-20 md:py-28">
      <div className="wrap">
        <div className="mx-auto max-w-[1280px]">
          <div data-reveal-stagger className="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-10 items-end">
            <div className="lg:col-span-7">
              <p className="font-label text-[12px] md:text-[13px] tracking-[0.2em] chapter-muted">OUR EXPERTISE</p>
              <h2 className="mt-5 font-display font-normal text-[clamp(2rem,3.6vw,3.25rem)] leading-[1.1] tracking-[-0.015em]">
                Expertise shaped around people.
              </h2>
            </div>
            <p className="lg:col-span-5 text-[16px] leading-[1.6] chapter-muted max-w-md">
              Three connected practices, each led by experienced consultants — focused on the people decisions that matter most to your organisation.
            </p>
          </div>

          <div data-reveal-stagger className="mt-12 md:mt-16 grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-5">
            {services.map((s, i) => (
              <Link
                key={s.number}
                to="/services"
                className="group flex flex-col h-full min-h-[300px] md:min-h-[380px] bg-background-50 border border-foreground-950/15 p-6 md:p-8 cursor-pointer transition-colors duration-300 ease-ui focus-ring hover:border-foreground-950/50"
              >
                <div className="flex items-center justify-between gap-4 pb-5 border-b border-foreground-950/15">
                  <span className="inline-block border border-foreground-950/40 px-3 py-1 font-label text-[12px] md:text-[13px] text-foreground-800">
                    {tags[i]}
                  </span>
                  <span className="font-label text-[13px] tracking-[0.12em] text-accent-600">{s.number}</span>
                </div>
                <h3 className="mt-8 font-display font-normal text-[28px] md:text-[30px] leading-[1.15] text-foreground-950">
                  {s.title}
                </h3>
                <p className="mt-4 flex-1 text-[15px] leading-[1.6] text-foreground-700 max-w-[34ch]">{s.summary}</p>
                <div className="mt-8 pt-5 border-t border-foreground-950/15">
                  <span className="inline-flex items-center gap-1 text-[14px] font-medium text-foreground-950 border-b border-foreground-950 pb-0.5 whitespace-nowrap group-hover:text-accent-600 group-hover:border-accent-500 transition-colors duration-200 ease-ui">
                    Explore service <i className="ri-arrow-right-up-line arrow-nudge"></i>
                  </span>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}